import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=3ddb8f70&scoped=true"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"
import style0 from "./notice.vue?vue&type=style&index=0&id=3ddb8f70&prod&lang=scss&scoped=true"
import style1 from "./notice.vue?vue&type=style&index=1&id=3ddb8f70&prod&scoped=true&lang=css"
import style2 from "./notice.vue?vue&type=style&index=2&id=3ddb8f70&prod&lang=scss&scoped=true"
import style3 from "./notice.vue?vue&type=style&index=3&id=3ddb8f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddb8f70",
  null
  
)

export default component.exports